import { NavigateFunction } from 'react-router-dom';
import { useConfirmStore } from '../store/confirm-store';

export function handleConfirmNavigation(navigate: NavigateFunction, path: string, message = 'Are you sure you want to leave this page?') {
    const openConfirm = useConfirmStore.getState().openConfirm;
    openConfirm(message, () => navigate(path));
}
